<footer>
	<span>Powered by <a href="https://ravendb.net" target="_blank">RavenDB</a></span>
</footer>
